(function (root, factory) {
  var productGallery = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = productGallery;
  }

  if (root) {
    root.EVERLA = root.EVERLA || {};
    root.EVERLA.productGallery = productGallery;
  }
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var imageAttributes = ['src', 'srcset', 'sizes', 'width', 'height', 'alt'];
  var focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';
  var controllerKey = '__everlaProductGalleryZoomController';

  function hasValue(value) {
    return value !== undefined && value !== null && value !== '';
  }

  function isElement(element) {
    return element && typeof element.setAttribute === 'function' && typeof element.removeAttribute === 'function';
  }

  function hasHiddenOrInertAncestor(element) {
    var current = element;
    var ariaHidden;

    while (current) {
      if (current.hidden || current.inert) return true;
      if (typeof current.hasAttribute === 'function') {
        if (current.hasAttribute('hidden') || current.hasAttribute('inert')) return true;
        ariaHidden = current.getAttribute('aria-hidden');
        if (ariaHidden && String(ariaHidden).toLowerCase() === 'true') return true;
      }
      current = current.parentNode;
    }

    return false;
  }

  function isTabbable(element) {
    var tabindex;
    var view;
    var style;
    var visibility;

    if (!element || typeof element.getAttribute !== 'function') return false;
    if (typeof element.tabIndex === 'number') {
      if (element.tabIndex < 0) return false;
    } else {
      tabindex = element.getAttribute('tabindex');
      if (tabindex !== null && parseInt(tabindex, 10) < 0) return false;
    }
    if (element.disabled || (typeof element.hasAttribute === 'function' && element.hasAttribute('disabled'))) return false;
    if (element.tagName === 'INPUT' && String(element.getAttribute('type') || '').toLowerCase() === 'hidden') return false;
    if (hasHiddenOrInertAncestor(element)) return false;
    view = element.ownerDocument && element.ownerDocument.defaultView;
    if (view && typeof view.getComputedStyle === 'function') {
      style = view.getComputedStyle(element);
      visibility = style && String(style.visibility || '').toLowerCase();
      if (style && String(style.display || '').toLowerCase() === 'none') return false;
      if (visibility === 'hidden' || visibility === 'collapse') return false;
    }
    if (typeof element.getClientRects === 'function' && element.getClientRects().length === 0) return false;
    return true;
  }

  function applyImage(img, media) {
    var index;
    var attribute;

    if (!isElement(img) || !media) return false;

    for (index = 0; index < imageAttributes.length; index += 1) {
      attribute = imageAttributes[index];
      if (hasValue(media[attribute])) {
        img.setAttribute(attribute, media[attribute]);
      } else {
        img.removeAttribute(attribute);
      }
    }

    return true;
  }

  function initZoom(scope, options) {
    var dialog;
    var dialogImage;
    var closeButton;
    var triggers;
    var lock;
    var opener = null;
    var isOpen = false;
    var destroyed = false;
    var controller;

    function noOp() {}

    function emptyController() {
      return { close: noOp, destroy: noOp, refresh: noOp };
    }

    if (!scope || typeof scope.querySelectorAll !== 'function') return emptyController();
    if (scope[controllerKey]) return scope[controllerKey];

    options = options || {};
    dialog = options.dialog;
    if (!dialog || typeof dialog.querySelector !== 'function' || typeof dialog.addEventListener !== 'function') {
      return emptyController();
    }

    triggers = [];
    dialogImage = dialog.querySelector('img');
    closeButton = dialog.querySelector('button');
    if (!dialogImage || !closeButton) return emptyController();

    lock = typeof options.lock === 'function' ? options.lock : noOp;

    function close() {
      var focusTarget;

      if (destroyed || !isOpen) return;
      isOpen = false;
      dialog.setAttribute('aria-hidden', 'true');
      dialog.classList.remove('is-open');
      lock(false);
      focusTarget = opener;
      opener = null;
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
    }

    function open(trigger, event) {
      var triggerImage = trigger.querySelector('img');
      var href = trigger.getAttribute('href');
      var alt = triggerImage ? triggerImage.getAttribute('alt') : '';

      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      opener = trigger;
      if (hasValue(href)) dialogImage.setAttribute('src', href);
      else dialogImage.removeAttribute('src');
      dialogImage.setAttribute('alt', alt || '');
      dialog.setAttribute('aria-hidden', 'false');
      dialog.classList.add('is-open');
      isOpen = true;
      lock(true);
      closeButton.focus();
    }

    function isModifiedActivation(event) {
      return event && (
        event.ctrlKey
        || event.metaKey
        || event.shiftKey
        || event.altKey
        || (typeof event.button === 'number' && event.button !== 0)
      );
    }

    function handleTriggerClick(event) {
      if (destroyed || isModifiedActivation(event)) return;
      open(event.currentTarget || this, event);
    }

    function handleCloseClick(event) {
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      close();
    }

    function handleDialogClick(event) {
      if (event.target === dialog) close();
    }

    function handleDialogKeydown(event) {
      var candidates;
      var focusable;
      var first;
      var last;
      var active;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== 'Tab' || !isOpen) return;
      candidates = dialog.querySelectorAll(focusableSelector);
      focusable = Array.prototype.filter.call(candidates, isTabbable);
      if (!focusable.length) return;
      first = focusable[0];
      last = focusable[focusable.length - 1];
      active = dialog.ownerDocument ? dialog.ownerDocument.activeElement : event.target;

      if (event.shiftKey && (active === first || !dialog.contains(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
        event.preventDefault();
        first.focus();
      }
    }

    function refresh() {
      if (destroyed) return;
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.removeEventListener('click', handleTriggerClick);
      });
      triggers = scope.querySelectorAll('[data-gallery-zoom]');
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.addEventListener('click', handleTriggerClick);
      });
    }

    function destroy() {
      if (destroyed) return;
      close();
      destroyed = true;
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.removeEventListener('click', handleTriggerClick);
      });
      closeButton.removeEventListener('click', handleCloseClick);
      dialog.removeEventListener('click', handleDialogClick);
      dialog.removeEventListener('keydown', handleDialogKeydown);
      if (scope[controllerKey] === controller) delete scope[controllerKey];
    }

    closeButton.addEventListener('click', handleCloseClick);
    dialog.addEventListener('click', handleDialogClick);
    dialog.addEventListener('keydown', handleDialogKeydown);

    controller = { close: close, destroy: destroy, refresh: refresh };
    scope[controllerKey] = controller;
    refresh();
    return controller;
  }

  function applyVariantMedia(scope, media, stickyImage) {
    var studio;
    var studioImage;
    var ownerDocument;

    if (!scope || typeof scope.querySelector !== 'function' || !media || !hasValue(media.src)) return false;
    studio = scope.querySelector('[data-gallery-slot="studio"]');
    if (!studio || typeof studio.querySelector !== 'function' || typeof studio.setAttribute !== 'function') return false;
    studioImage = studio.querySelector('img');
    if (!studioImage) {
      ownerDocument = studio.ownerDocument;
      if (!ownerDocument || typeof ownerDocument.createElement !== 'function' || typeof studio.appendChild !== 'function') return false;
      studioImage = ownerDocument.createElement('img');
      studioImage.setAttribute('class', 'studio');
      studio.appendChild(studioImage);
    }

    applyImage(studioImage, media);
    studioImage.removeAttribute('hidden');
    studio.setAttribute('href', media.zoom || media.src);
    studio.setAttribute('data-gallery-zoom', '');
    studio.removeAttribute('hidden');
    studio.removeAttribute('role');
    studio.removeAttribute('aria-label');
    if (studio.classList) studio.classList.remove('ev-gal-missing');
    if (stickyImage) applyImage(stickyImage, media);
    if (scope[controllerKey] && typeof scope[controllerKey].refresh === 'function') scope[controllerKey].refresh();
    return true;
  }

  return {
    applyImage: applyImage,
    initZoom: initZoom,
    applyVariantMedia: applyVariantMedia
  };
}));
